'use client';

import { AtomicSortDropdown, AtomicSortExpression } from '@coveo/atomic-react';

const styles = `
atomic-sort-dropdown {
  width: min-content;
}

atomic-sort-dropdown::part(label) {
  width: 100%;
  margin-top: 0;
  margin-left: 0px;
  line-height: 20px;
  font-weight: 400;
  font-size: 14px;
  color: var(--atomic-custom-grey-600);
  display: block;
}

atomic-sort-dropdown::part(select) {
  flex-grow: unset;
  padding-right: 1.5rem;
  border-color: var(--atomic-custom-grey-400);
  background-color: var(--atomic-custom-grey-100);
  border-radius: var(--atomic-border-radius-md);
  color: var(--atomic-custom-grey-600);
  font-weight: 500;
}

atomic-sort-dropdown::part(select):hover {
  color: var(--atomic-custom-grey-700);
}

atomic-sort-dropdown::part(select):focus {
  background-color: var(--atomic-custom-white);
  color: var(--atomic-custom-grey-700);
}

atomic-sort-dropdown::part(select-separator) {
  width: 2rem;
  color: var(--atomic-custom-grey-600);
  border-color: transparent;
}
`;

const sortOptions = [
  {
    label: 'relevance',
    expression: 'relevancy',
  },
  {
    label: 'rating',
    expression: 'ec_rating descending, ec_rating_count descending',
  },
  {
    label: 'published-date',
    expression: 'first_published_at descending',
  },
  {
    label: 'recently-updated',
    expression: 'last_published_at descending',
  },
  {
    label: 'price-low-to-high',
    expression: 'ec_price_filter ascending',
  },
  {
    label: 'price-high-to-low',
    expression: 'ec_price_filter descending',
  },
  /**
   * TODO: Not available in the index yet.
   * When it becomes available this should be reintroduced
   */
  // {
  //   label: 'most-favorited',
  //   expression: 'ec_favorited descending',
  // },
];

export const AtomicSorting = () => {
  return (
    <>
      <style>{styles}</style>
      <AtomicSortDropdown>
        {sortOptions.map((option) => (
          <AtomicSortExpression
            key={option.expression}
            label={option.label}
            expression={option.expression}
          />
        ))}
      </AtomicSortDropdown>
    </>
  );
};
